/* eslint-disable react/no-danger */
import * as Styles from "./styles";

const TrudyLinesPage = (): JSX.Element => {
  const iframeContent = {
    __html: '<iframe src="/drops/trudy-lines/index.html"></iframe>',
  };

  return (
    <Styles.Container>
      <Styles.GlobalStyleWrapper />
      <div dangerouslySetInnerHTML={iframeContent} />
    </Styles.Container>
  );
};

export default TrudyLinesPage;
